module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/mags/ortho-field-config-translation.json
// module id = 1220
// module chunks = 0